import { Component } from '@angular/core';

@Component({
  selector: 'app-house-flat-visits-page',
  templateUrl: './house-flat-visits-page.component.html',
  styleUrl: './house-flat-visits-page.component.scss'
})
export class HouseFlatVisitsPageComponent {

}
